<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaEspecialidades"
        title-table="Especialidades"
        module="especialidadeSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_ESPECIALIDADE_INSERIR"
        view-permission="ROLE_ESPECIALIDADE_CONSULTAR"
        edit-permission="ROLE_ESPECIALIDADE_ATUALIZAR"
        delete-permission="ROLE_ESPECIALIDADE_DELETAR"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormEspecialidade
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormEspecialidade from './forms/FormEspecialidade.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormEspecialidade,
  },
  computed: {
    ...mapState('especialidadeSettingsModule', {
      listaEspecialidades: state => state.listaEspecialidades,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Valor',
          field: 'valor',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('especialidadeSettingsModule/reset')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'especialidadeSettingsModule/prepareToEditEspecialidade',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
